import React from "react"

// Figma: 와우넷 숏폼 AI 요약 / AI 요약 버튼 (node 3:1642)
export default function AiIcon() {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2278 0.8125H3.27479C1.9149 0.8125 0.8125 1.77189 0.8125 2.95536V23.6696C0.8125 24.8531 1.9149 25.8125 3.27479 25.8125H17.2278C18.5876 25.8125 19.6901 24.8531 19.6901 23.6696V2.95536C19.6901 1.77189 18.5876 0.8125 17.2278 0.8125Z"
        fill="url(#aiGrad)"
        stroke="#E2E4E7"
        strokeWidth="1.625"
      />
      <path
        d="M6.62427 12.5115H5.00708L7.16919 6.14819H9.15552L11.3088 12.5115H9.70044L9.26978 11.1492H7.05493L6.62427 12.5115ZM7.41528 10.0066H8.90942L8.18872 7.72144H8.13599L7.41528 10.0066ZM13.4797 6.14819V12.5115H11.9856V6.14819H13.4797Z"
        fill="#EA4335"
      />
      <path
        d="M13.912 15.0344H5.12374C4.57428 15.0344 4.12885 15.4799 4.12885 16.0293C4.12885 16.5788 4.57428 17.0242 5.12374 17.0242H13.912C14.4615 17.0242 14.9069 16.5788 14.9069 16.0293C14.9069 15.4799 14.4615 15.0344 13.912 15.0344Z"
        fill="#4285F4"
      />
      <path
        d="M10.5957 19.1799H5.12374C4.57428 19.1799 4.12885 19.6253 4.12885 20.1748C4.12885 20.7242 4.57428 21.1697 5.12374 21.1697H10.5957C11.1451 21.1697 11.5906 20.7242 11.5906 20.1748C11.5906 19.6253 11.1451 19.1799 10.5957 19.1799Z"
        fill="#4285F4"
      />
      <g>
        <path
          d="M24.3652 7.23004L22.7972 6.005C22.4364 5.7231 21.9154 5.78707 21.6335 6.14789L20.9189 7.06255C20.637 7.42337 20.701 7.9444 21.0618 8.22631L22.6298 9.45135C22.9906 9.73325 23.5116 9.66928 23.7935 9.30846L24.5081 8.3938C24.79 8.03298 24.726 7.51195 24.3652 7.23004Z"
          fill="#EA4335"
        />
        <path
          d="M22.4707 9.11651L21.4253 8.29981C20.9202 7.90515 20.1907 7.99471 19.7961 8.49986L13.5688 16.4704C13.1741 16.9756 13.2637 17.705 13.7688 18.0997L14.8142 18.9164C15.3193 19.3111 16.0487 19.2215 16.4434 18.7163L22.6707 10.7458C23.0654 10.2406 22.9758 9.51117 22.4707 9.11651Z"
          fill="#FBBC04"
        />
        <path
          d="M12.8541 17.3851L15.7288 19.631L12.0455 21.3827L12.8541 17.3851Z"
          fill="#5F6368"
        />
      </g>
      <path
        d="M15.9361 1.34314C16.288 3.10251 16.9917 3.80626 18.7511 4.15814C16.9917 4.51001 16.288 5.21376 15.9361 6.97314C15.5842 5.21376 14.8805 4.51001 13.1211 4.15814C14.8805 3.80626 15.5842 3.10251 15.9361 1.34314Z"
        fill="#FBBC04"
      />
      <defs>
        <linearGradient
          id="aiGrad"
          x1="0.8125"
          y1="0.8125"
          x2="16.2386"
          y2="27.7863"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#EEF0F2" />
        </linearGradient>
      </defs>
    </svg>
  )
}
